import { Controller } from "@hotwired/stimulus";
import * as d3 from "d3";
import geoData from "./data/departments.json";
class default_1 extends Controller {
    async connect() {
        const counts = await fetch(this.urlValue).then((r) => r.json());
        this.renderMap(geoData, counts);
    }
    renderMap(geoData, counts) {
        const width = 600;
        const height = 550;
        const svg = d3
            .select(this.element)
            .append("svg")
            .attr("width", width)
            .attr("height", height);
        // France centered map
        const projection = d3
            .geoConicConformal()
            .center([2.454071, 46.279229])
            .scale(2800)
            .translate([width / 2, height / 2]);
        const path = d3.geoPath().projection(projection);
        const maxCount = d3.max(Object.values(counts)) || 1;
        const colorScale = d3
            .scaleSequential(d3.interpolateBlues)
            .domain([0, maxCount]);
        // Tooltip
        const tooltip = d3
            .select(this.element)
            .append("div")
            .attr("class", "map-tooltip")
            .style("position", "absolute")
            .style("background", "white")
            .style("border", "1px solid #a29c9c")
            .style("padding", "6px 10px")
            .style("border-radius", "4px")
            .style("pointer-events", "none")
            .style("display", "none");
        // Departments
        svg
            .selectAll("path")
            .data(geoData.features)
            .enter()
            .append("path")
            .attr("d", path)
            .attr("fill", (d) => {
            const code = d.properties.code;
            return counts[code] ? colorScale(counts[code]) : "#eee";
        })
            .attr("stroke", "#fff")
            .attr("stroke-width", 0.5)
            .on("mousemove", (event, d) => {
            const code = d.properties.code;
            const name = d.properties.nom;
            const count = counts[code] || 0;
            tooltip
                .style("display", "block")
                .style("left", `${event.offsetX + 10}px`)
                .style("top", `${event.offsetY - 20}px`)
                .html(`<strong>${name}</strong><br/>${count} ${this.legendValue}`);
        })
            .on("mouseleave", () => tooltip.style("display", "none"));
        // Legend
        this.renderLegend(svg, colorScale, maxCount, width);
    }
    renderLegend(svg, colorScale, maxCount, width) {
        const legendWidth = 200;
        const legendHeight = 10;
        const x = width - legendWidth - 20;
        const y = 20;
        const defs = svg.append("defs");
        const gradient = defs
            .append("linearGradient")
            .attr("id", "legend-gradient");
        gradient
            .selectAll("stop")
            .data(d3.range(0, 1.1, 0.1))
            .enter()
            .append("stop")
            .attr("offset", (d) => `${d * 100}%`)
            .attr("stop-color", (d) => colorScale(d * maxCount));
        svg
            .append("rect")
            .attr("x", x)
            .attr("y", y)
            .attr("width", legendWidth)
            .attr("height", legendHeight)
            .style("fill", "url(#legend-gradient)");
        const legendScale = d3
            .scaleLinear()
            .domain([0, maxCount])
            .range([0, legendWidth]);
        svg
            .append("g")
            .attr("transform", `translate(${x}, ${y + legendHeight})`)
            .call(d3.axisBottom(legendScale).ticks(4).tickSize(3));
    }
}
default_1.values = { url: String, legend: String };
export default default_1;
